import PrimaryButton from "@/components/ui/primary-button";
import { cn } from "@/lib/utils";
import Image, { StaticImageData } from "next/image";

export interface LocationCTAProps {
  heading?: string;
  image?: {
    className?: string;
    src: string | StaticImageData;
    alt: string;
  };
  cta?: {
    text: string;
    href: string;
  };
}

const LocationCTA = ({ heading, image, cta }: LocationCTAProps) => {
  return (
    <section className="flex w-full bg-white">
      <div
        className={cn(
          "flex w-full flex-col gap-2 p-4 md:gap-2 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:px-3 lg:py-10"
        )}
      >
        <div
          className={cn(
            "flex w-full gap-6 px-4 py-8 md:px-6 md:py-10 lg:p-20",
            "rounded-3xl shadow-[4px_4px_0px_0px_#FFD5BF] md:shadow-[6px_6px_0px_0px_#FFD5BF] lg:shadow-[8px_8px_0px_0px_#FFD5BF]",
            "relative overflow-clip",
            "max-h-[144px] md:max-h-[178px] lg:max-h-[264px]",
            "h-[144px] md:h-[178px] lg:h-[264px]"
          )}
        >
          <div className="z-10 flex flex-col justify-center gap-2 md:gap-4">
            {heading && (
              <h3 className="font-montserrat text-subheading-3-500 text-white md:text-subheading-2 lg:text-subheading-1">
                {heading}
              </h3>
            )}
            {cta && (
              <PrimaryButton
                className="w-fit"
                color="orange-light"
                href={cta.href}
              >
                {cta.text}
              </PrimaryButton>
            )}
          </div>
          {image && image.src && (
            <Image
              src={image.src}
              alt={image?.alt || ""}
              fill
              className={cn("object-cover object-[25%_30%]", image?.className)}
            />
          )}
          <div className="absolute inset-0 z-0 flex w-full bg-gradient-to-r from-secondary-500 from-[23.72%] via-secondary-500/50 via-[53.36%] to-transparent to-[77.9%]" />
        </div>
      </div>
    </section>
  );
};

export default LocationCTA;
